import orderBy from "lodash.orderby";
import { Building } from "lucide-react";

import { IgTypography } from "@intelligems/ig-theme/IgTypography";
import { OrganizationListDto } from "@intelligems/ig-types/dtos/organizations-list";
import { Stack } from "@mui/material";
import { useSwitchOrganization } from "@src/api/organizations/switch-organization";
import { useGetOrgList } from "@src/api/organizations-list/get-organization-list";
import { getAuthToken } from "@src/utils";

import { SearchOption } from "./types";
import { tokenizedMatches } from "./utils";

export const useOrgListOptions = (
  query?: string,
  limit?: number
): SearchOption[] => {
  const { data: orgList, isSuccess: orgListSuccess } = useGetOrgList();
  const switchOrg = useSwitchOrganization();

  if (!orgListSuccess || orgList.orgs.length <= 1) {
    return [];
  }

  const doSwitch = (orgId: string) => {
    switchOrg.mutate({
      token: getAuthToken() || "",
      orgId: orgId,
    });
  };

  const toOption = (org: OrganizationListDto): SearchOption => ({
    group: "Organizations",
    render: () => {
      return (
        <Stack direction={"row"} alignItems={"center"}>
          <Building size={20} />
          <IgTypography marginLeft={2}>{org.name}</IgTypography>
        </Stack>
      );
    },
    select: () => {
      doSwitch(org.id);
    },
  });

  let filtered = orderBy(orgList.orgs, ["name"], ["asc"]);
  if (query) {
    const lower = query.toLowerCase();
    filtered = filtered.filter((org) => {
      if (org.id.toLowerCase().includes(lower)) {
        return true;
      }
      if (org.name.length && tokenizedMatches(lower, org.name.toLowerCase())) {
        return true;
      }
      if (
        org.shopId.length &&
        tokenizedMatches(lower, org.shopId.toLowerCase())
      ) {
        return true;
      }
      return false;
    });
  }

  return filtered.slice(0, limit).map((org) => toOption(org));
};
